import { auto } from '@popperjs/core';
import Swiper, { Navigation, Pagination } from 'swiper';
import SliderPlugin from './slider-plugin';
Swiper.use([Navigation, Pagination]);

class MoreProgramsSliderPlugin extends SliderPlugin {

    static type: String = "more-programs-slider"

    constructor(element: HTMLElement) {
        super(element);
    }

    init() {
        //let cssClasses = this.makeUnique();
        let buttons = this.getButtons();
        this.swiper = new Swiper(this.getClassPath(), {
            slidesPerView: auto,
            spaceBetween: 10,
            navigation: {
                nextEl: buttons.nextBtn,
                prevEl: buttons.prevBtn,
            },
            breakpointsBase: 'container',
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                722: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
            },
        });

        
        this.swiper.on('slideChange', function () {
            window.lazyload.update();
        });

    }
}

export default MoreProgramsSliderPlugin;